/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Admin_Could_Not_Load_UsersInputs */

const en_mobile_admin_could_not_load_users = /** @type {(inputs: Mobile_Admin_Could_Not_Load_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load users.`)
};

const es_mobile_admin_could_not_load_users = /** @type {(inputs: Mobile_Admin_Could_Not_Load_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar los usuarios.`)
};

/**
* | output |
* | --- |
* | "Could not load users." |
*
* @param {Mobile_Admin_Could_Not_Load_UsersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_admin_could_not_load_users = /** @type {((inputs?: Mobile_Admin_Could_Not_Load_UsersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Admin_Could_Not_Load_UsersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_admin_could_not_load_users(inputs)
	return en_mobile_admin_could_not_load_users(inputs)
});